import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Box, Button, Alert } from '@mui/material';

const PaymentCancelledPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Optional: You could clear any pending payment state here if needed
    // For now, just redirects after a delay.
    const timer = setTimeout(() => {
      navigate('/'); // Redirect to home or dashboard
    }, 5000); // 5-second delay

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box sx={{ textAlign: 'center', mt: 8, p: 3 }}>
      <Alert severity="warning" sx={{ mb: 3 }}>
        <Typography variant="h5" gutterBottom>
          Payment Cancelled or Failed
        </Typography>
        <Typography variant="body1">
          Your payment process was not completed. Your subscription has not been activated.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          If you believe this is an error, please try again or contact support.
        </Typography>
      </Alert>
      <Button variant="contained" onClick={() => navigate('/')}>
        Return to Dashboard
      </Button>
      <Typography sx={{ mt: 2, color: 'text.secondary' }}>
        You will be redirected automatically shortly.
      </Typography>
    </Box>
  );
};

export default PaymentCancelledPage; 